import { render, staticRenderFns } from "./WhatsappNotify.vue?vue&type=template&id=2233bba5&"
import script from "./WhatsappNotify.vue?vue&type=script&lang=js&"
export * from "./WhatsappNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports